var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    width: 96,
    height: 64,
    rx: 8,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4935 20.2275H54.4592V43.9539H41.4935V20.2275Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3167 32.091C42.3167 27.2703 44.5393 22.9945 47.9556 20.2277C45.4449 18.2156 42.2756 17 38.8181 17C30.6268 17 24 23.7489 24 32.091C24 40.4328 30.6268 47.1819 38.8179 47.1819C42.2754 47.1819 45.4447 45.9663 47.9556 43.954C44.5393 41.2293 42.3167 36.9116 42.3167 32.091Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9524 32.091C71.9524 40.4328 65.3256 47.1819 57.1345 47.1819C53.677 47.1819 50.5076 45.9663 47.9968 43.954C51.4543 41.1875 53.6359 36.9116 53.6359 32.091C53.6359 27.2703 51.4131 22.9945 47.9968 20.2277C50.5075 18.2156 53.677 17 57.1345 17C65.3256 17 71.9526 23.7909 71.9526 32.091H71.9524Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.77524af5e2d003b0e6fe7323e8e706be.svg";
export { ForwardRef as ReactComponent };